import TierFamilyImage from 'assets/images/tier_family.png'
import TierPersonalImage from 'assets/images/tier_personal.png'
import { getRemoteStrings } from 'components/HOCs/withRemoteStrings/withRemoteStrings'

const DEFAULT_COPY = {
  headline: 'Simple, transparent plans',
  subheadline:
    'We bundle our products into subscription tiers that support your financial wellness.',
  tiers: {
    bronze: {
      body:
        'Invest spare change, earn bonus investments, protect what you love, and grow your knowledge.',
      cta: 'Choose this plan',
      preferredTierText: 'Most popular',
    },
    silver: {
      body:
        'Easy, all-in-one investment, retirement, and checking accounts, to help you save and invest every day.',
      cta: 'Choose this plan',
      preferredTierText: 'All-in-one',
    },
    gold: {
      body:
        'Investment account for kids, plus personal investment, retirement, and checking accounts, to help your whole family grow!',
      cta: 'Choose this plan',
      preferredTierText: 'All-in-one',
    },
    platinum: {},
  },
  products: {
    invest: {
      title: 'Invest',
      subtitle: 'Investment account',
      value_prop_1: 'Put your spare change to work with our Round-Ups®',
      value_prop_2:
        'Earn bonus investments when you shop from 12,000+ brands in our app or with our Safari and Chrome Extensions',
      value_prop_3: 'Grow your knowledge with hundreds of articles from financial experts',
    },
    later: {
      title: 'Later',
      subtitle: 'Retirement account',
      value_prop_1: 'An easy way to save for retirement',
      value_prop_2: 'Earn potential tax advantages',
      value_prop_3: 'Updated regularly to match your goals',
    },
    spend: {
      title: 'Spend',
      subtitle: 'Checking account',
      value_prop_1: 'Invest spare change while you swipe with Real-Time Round-Ups®',
      value_prop_2: 'Get paid up to 2 days early when you set up your direct deposit',
      value_prop_3: 'Automatically invest a piece of every paycheck with Smart Deposit™',
      value_prop_4:
        '55,000+ fee-free ATMs plus no low balance or overdraft fees, and up to 10% bonus investments',
    },
    early: {
      title: 'Early',
      subtitle: 'Investment account for kids',
      value_prop_1: 'Open in under 3 minutes',
      value_prop_2: 'Multiple kids at no added cost',
      value_prop_3: 'Automatic Recurring Investments',
      value_prop_4: 'Exclusive bonus investments',
      value_prop_5: 'Family financial education',
      value_prop_6: 'Potential tax savings while they grow',
      value_prop_7: 'Flexibility with the funds',
    },
    premium_education: {},
  },
}

export const DYNAMIC_COPY = {
  headline: getRemoteStrings('headline', DEFAULT_COPY.headline, 'select_tier', true),
  subheadline: getRemoteStrings('subheadline', DEFAULT_COPY.subheadline, 'select_tier', true),
  tiers: {
    bronze: {
      body: getRemoteStrings('bronze_body', DEFAULT_COPY.tiers.bronze.body, 'select_tier', true),
      cta: getRemoteStrings('bronze_cta', DEFAULT_COPY.tiers.bronze.cta, 'select_tier', true),
      preferredTierText: getRemoteStrings(
        'bronze_preferred_tier_text',
        DEFAULT_COPY.tiers.bronze.preferredTierText,
        'select_tier',
        true,
      ),
    },
    silver: {
      body: getRemoteStrings('silver_body', DEFAULT_COPY.tiers.silver.body, 'select_tier', true),
      cta: getRemoteStrings('silver_cta', DEFAULT_COPY.tiers.silver.cta, 'select_tier', true),
      preferredTierText: getRemoteStrings(
        'silver_preferred_tier_text',
        DEFAULT_COPY.tiers.silver.preferredTierText,
        'select_tier',
        true,
      ),
    },
    gold: {
      body: getRemoteStrings('gold_body', DEFAULT_COPY.tiers.gold.body, 'select_tier', true),
      cta: getRemoteStrings('gold_cta', DEFAULT_COPY.tiers.gold.cta, 'select_tier', true),
      preferredTierText: getRemoteStrings(
        'gold_preferred_tier_text',
        DEFAULT_COPY.tiers.gold.preferredTierText,
        'select_tier',
        true,
      ),
    },
  },
  products: {
    invest: {
      title: getRemoteStrings(
        'invest_title',
        DEFAULT_COPY.products.invest.title,
        'select_tier',
        true,
      ),
      subtitle: getRemoteStrings(
        'invest_subtitle',
        DEFAULT_COPY.products.invest.subtitle,
        'select_tier',
        true,
      ),
      value_prop_1: getRemoteStrings(
        'invest_value_prop_1',
        DEFAULT_COPY.products.invest.value_prop_1,
        'select_tier',
        true,
      ),
      value_prop_2: getRemoteStrings(
        'invest_value_prop_2',
        DEFAULT_COPY.products.invest.value_prop_2,
        'select_tier',
        true,
      ),
      value_prop_3: getRemoteStrings(
        'invest_value_prop_3',
        DEFAULT_COPY.products.invest.value_prop_3,
        'select_tier',
        true,
      ),
    },
    later: {
      title: getRemoteStrings(
        'later_title',
        DEFAULT_COPY.products.later.title,
        'select_tier',
        true,
      ),
      subtitle: getRemoteStrings(
        'later_subtitle',
        DEFAULT_COPY.products.later.subtitle,
        'select_tier',
        true,
      ),
      value_prop_1: getRemoteStrings(
        'later_value_prop_1',
        DEFAULT_COPY.products.later.value_prop_1,
        'select_tier',
        true,
      ),
      value_prop_2: getRemoteStrings(
        'later_value_prop_2',
        DEFAULT_COPY.products.later.value_prop_2,
        'select_tier',
        true,
      ),
      value_prop_3: getRemoteStrings(
        'later_value_prop_3',
        DEFAULT_COPY.products.later.value_prop_3,
        'select_tier',
        true,
      ),
    },
    spend: {
      title: getRemoteStrings(
        'spend_title',
        DEFAULT_COPY.products.spend.title,
        'select_tier',
        true,
      ),
      subtitle: getRemoteStrings(
        'spend_subtitle',
        DEFAULT_COPY.products.spend.subtitle,
        'select_tier',
        true,
      ),
      value_prop_1: getRemoteStrings(
        'spend_value_prop_1',
        DEFAULT_COPY.products.spend.value_prop_1,
        'select_tier',
        true,
      ),
      value_prop_2: getRemoteStrings(
        'spend_value_prop_2',
        DEFAULT_COPY.products.spend.value_prop_2,
        'select_tier',
        true,
      ),
      value_prop_3: getRemoteStrings(
        'spend_value_prop_3',
        DEFAULT_COPY.products.spend.value_prop_3,
        'select_tier',
        true,
      ),
      value_prop_4: getRemoteStrings(
        'spend_value_prop_4',
        DEFAULT_COPY.products.spend.value_prop_4,
        'select_tier',
        true,
      ),
    },
    early: {
      title: getRemoteStrings(
        'early_title',
        DEFAULT_COPY.products.early.title,
        'select_tier',
        true,
      ),
      subtitle: getRemoteStrings(
        'early_subtitle',
        DEFAULT_COPY.products.early.subtitle,
        'select_tier',
        true,
      ),
      value_prop_1: getRemoteStrings(
        'early_value_prop_1',
        DEFAULT_COPY.products.early.value_prop_1,
        'select_tier',
        true,
      ),
      value_prop_2: getRemoteStrings(
        'early_value_prop_2',
        DEFAULT_COPY.products.early.value_prop_2,
        'select_tier',
        true,
      ),
      value_prop_3: getRemoteStrings(
        'early_value_prop_3',
        DEFAULT_COPY.products.early.value_prop_3,
        'select_tier',
        true,
      ),
      value_prop_4: getRemoteStrings(
        'early_value_prop_4',
        DEFAULT_COPY.products.early.value_prop_4,
        'select_tier',
        true,
      ),
      value_prop_5: getRemoteStrings(
        'early_value_prop_5',
        DEFAULT_COPY.products.early.value_prop_5,
        'select_tier',
        true,
      ),
      value_prop_6: getRemoteStrings(
        'early_value_prop_6',
        DEFAULT_COPY.products.early.value_prop_6,
        'select_tier',
        true,
      ),
      value_prop_7: getRemoteStrings(
        'early_value_prop_7',
        DEFAULT_COPY.products.early.value_prop_7,
        'select_tier',
        true,
      ),
    },
    premium_education: {
      title: 'Premium Education',
      subtitle: 'Live Q&A with financial experts',
    },
    benefits_will_standard: {
      title: 'Benefits',
      subtitle: 'Plan ahead with a complimentary Will',
    },
  },
}

export const V1_COPY = {
  silver: {
    subTitle:
      'All-in-one investment, retirement, and checking, plus a metal debit card, bonus investments, and more. Over 10 million customers signed up!',
    image: TierPersonalImage,
    groups: [
      {
        key: 'early',
        title: 'Early for Kids',
        disabled: true,
        options: [
          { text: 'Unlimited investment portfolios for all the kids you love ', checked: false },
          { text: 'Invite friends and family to gift contributions', checked: false },
          {
            text: 'UGMA/UTMA accounts for extra flexibility and potential tax benefits ',
            checked: false,
          },
        ],
      },
      {
        key: 'invest',
        title: 'Investing',
        options: [
          { text: 'Expert-built portfolio catered to your goals', checked: true },
          {
            text: 'Invest spare change from every purchase and make auto-Recurring Investments',
            checked: true,
          },
          { text: 'Retirement account for tax advantages', checked: true },
        ],
      },
      {
        key: 'spend',
        title: 'Banking',
        options: [
          {
            text: 'Automatically invest a piece of every paycheck',
            checked: true,
          },
          { text: 'Make daily investments with Real-Time Round-Ups®', checked: true },
          { text: 'Custom metal card with fee-free ATMs', checked: true },
          {
            text:
              'Get paid early with direct deposit, plus mobile check deposit and digital checks',
            checked: true,
          },
        ],
      },
      {
        key: 'later',
        title: 'Earning & Learning',
        options: [
          {
            text: 'Earn bonus investments from 20k+ brands for you and your family',
            checked: true,
          },
          {
            text: 'Study up on money tips and tricks, and grow your knowledge as you go',
            checked: true,
          },
        ],
      },
    ],
  },
  gold: {
    subTitle:
      'Get a full suite of financial wellness tools so your family can save and invest for a bright future. Over 10 million customers signed up!',
    image: TierFamilyImage,
    groups: [
      {
        key: 'early',
        title: 'Early for Kids',
        options: [
          { text: 'Unlimited investment portfolios for all the kids you love ', checked: true },
          { text: 'Invite friends and family to gift contributions', checked: true },
          {
            text: 'UGMA/UTMA accounts for extra flexibility and potential tax benefits ',
            checked: true,
          },
        ],
      },
      {
        key: 'invest',
        title: 'Investing',
        options: [
          { text: 'Expert-built portfolio catered to your goals', checked: true },
          {
            text: 'Invest spare change from every purchase and make auto-Recurring Investments',
            checked: true,
          },
          { text: 'Retirement account for tax advantages', checked: true },
        ],
      },
      {
        key: 'spend',
        title: 'Banking',
        options: [
          {
            text: 'Auto-invest a piece of every paycheck for yourself and your kids ',
            checked: true,
          },
          { text: 'Make daily investments with Real-Time Round-Ups®', checked: true },
          { text: 'Custom metal card with fee-free ATMs', checked: true },
          {
            text:
              'Get paid early with direct deposit, plus mobile check deposit and digital checks',
            checked: true,
          },
        ],
      },
      {
        key: 'later',
        title: 'Earning & Learning',
        options: [
          {
            text: 'Earn bonus investments from 20k+ brands for you and your family',
            checked: true,
          },
          {
            text: 'Study up on money tips and tricks, and grow your knowledge as you go',
            checked: true,
          },
        ],
      },
    ],
  },
}
